export type SupplyChainGrnStatus = 'open' | 'converted' | 'cancelled'

export type SupplyChainGrnLine = {
  id: string
  itemId?: string
  itemName: string
  orderQuantity: number
  quantityReceived: number
  toReceive: number
  unitPrice: number
  discountPercent: number
  costLedgerAccountId?: string
  taxId?: string
  taxPercent: number
}

export type SupplyChainGrn = {
  id: string
  code: string
  reference: string
  vendor: string
  warehouse: string
  purchaseOrderCode: string
  orderDate: string // YYYY-MM-DD
  grnDate: string // YYYY-MM-DD
  grnReference: string
  attachmentName?: string
  status: SupplyChainGrnStatus
  isBillCreated: boolean
  lines: SupplyChainGrnLine[]
  createdAt: string
  updatedAt: string
}

export type SupplyChainGrnRow = {
  id: string
  code: string
  reference: string
  warehouse: string
  vendor: string
  orderCode: string
  date: string
  total: number
  status: SupplyChainGrnStatus
  isBillCreated: boolean
}

export function computeGrnLineTotals(l: SupplyChainGrnLine) {
  // Supply Chain GRN uses PO line quantity as the effective qty (UI doesn't capture "received/to receive")
  const qty = Number(l.orderQuantity || 0)
  const unitPrice = Number(l.unitPrice || 0)
  const gross = qty * unitPrice
  const disc = gross * (Number(l.discountPercent || 0) / 100)
  const taxable = Math.max(0, gross - disc)
  const tax = taxable * (Number(l.taxPercent || 0) / 100)
  const total = taxable + tax
  return {
    qty,
    gross,
    discountAmount: disc,
    taxableAmount: taxable,
    taxAmount: tax,
    lineTotal: total,
  }
}

export function computeGrnTotals(lines: SupplyChainGrnLine[]) {
  const totals = (lines || []).reduce(
    (acc, l) => {
      const t = computeGrnLineTotals(l)
      acc.subTotal += t.taxableAmount
      acc.totalTax += t.taxAmount
      acc.net += t.lineTotal
      acc.discount += t.discountAmount
      return acc
    },
    { subTotal: 0, totalTax: 0, discount: 0, net: 0 },
  )
  return totals
}

